
import {defineComponent} from 'vue';
import {toastMixin} from './toast-mixin';
import Text from '@ohrm/oxd/core/components/Text/Text.vue';
import ToastCloseButton from '@ohrm/oxd/core/components/Toast/CloseButton.vue';
import ToastIcon from '@ohrm/oxd/core/components/Toast/Icon.vue';

export default defineComponent({
  name: 'oxd-toast',

  mixins: [toastMixin],

  components: {
    'oxd-text': Text,
    'oxd-toast-close-button': ToastCloseButton,
    'oxd-toast-icon': ToastIcon,
  },

  emits: ['update:show'],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-toast': true,
        [`oxd-toast--${this.type}`]: true,
        ['oxd-toast--persistent']: this.persistent,
      };
    },
    contentClasses(): object {
      return {
        'oxd-toast-content': true,
        [`oxd-toast-content--${this.type}`]: true,
      };
    },
  },

  methods: {
    onClickToast() {
      if (!this.persistent) {
        this.$emit('update:show', false);
      }
    },
    onClickClose(e: Event) {
      e.stopPropagation();
      this.$emit('update:show', false);
    },
  },
});
